module.exports = __webpack_public_path__ + "static/media/gym-zoomed-2.a8b87f30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/gym-zoomed-2.jpg
// module id = 2385
// module chunks = 0